import { FC } from 'react';
import { css } from '@emotion/css';
import colors from '@prezzee/ribbon-ui/lib/theme/foundations/colors';

import CmsImage from '../CmsImage';

interface Props {
  icon: {
    src: string;
    alt: string;
    width: number;
    height: number;
  };
  title: string;
  description: string;
}

const Styles = {
  container: css`
    display: flex;
    align-items: center;
    padding: 36px 0 24px;
  `,
  textContainer: css`
    margin-left: 16px;
  `,
  title: css`
    font-size: 27px;
    line-height: 34px;
    font-weight: 600;
    color: ${colors.gray[800]};
  `,
  description: css`
    font-size: 16px;
    line-height: 24px;
    margin-top: 8px;
    color: ${colors.gray[600]};
  `,
  image: css`
    width: 72px;
  `,
};

const NoSearchResults: FC<Props> = ({ icon, title, description }) => (
  <div className="mx-4">
    <div className={Styles.container}>
      <CmsImage
        src={icon.src}
        alt={icon.src}
        width={icon.width}
        height={icon.height}
        sizes={`${icon.width}px`}
        className={Styles.image}
      />
      <div className={Styles.textContainer}>
        <h2 className={Styles.title}>{title}</h2>
        <p className={Styles.description}>{description}</p>
      </div>
    </div>
    <hr />
  </div>
);

export default NoSearchResults;
